export default "__VITE_ASSET__xKv_G3tL__"